// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__ONIX3","loaderOuter":"PageOverlayLoader_loaderOuter__1NilF"};